module.exports = __webpack_public_path__ + "static/media/rilee-marks.5565bed3.jpg";